import { render, staticRenderFns } from "./ScoreCounter.vue?vue&type=template&id=93b8dd8a&scoped=true&"
import script from "./ScoreCounter.vue?vue&type=script&lang=js&"
export * from "./ScoreCounter.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCounter.vue?vue&type=style&index=0&id=93b8dd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b8dd8a",
  null
  
)

export default component.exports